import React, { useState } from 'react';
import { Button, FormControl , Modal, } from 'react-bootstrap';
import { markPaymentReceiptAsPartiallyPayed } from '../../../../../../../../../../../crud/payments_api/payment_receipts';
import {FaBan,FaMoneyBillWave, FaX } from 'react-icons/fa6';
import {formatCurrency} from '../../../../../../../../../../../utils/functions';
//import './ActionSection.scss';
import { toast } from 'react-toastify';
import MiniLoadingSpinner from '../../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './InsufficientPayment.scss';

interface InsufficientPaymentProps {
  show: boolean;
  receiptId: any;
  receipt: any;
  receipts: any[];
  setReceipts: (receipts: any[]) => void;
  setCurrentIndex: (index: number) => void;
  onClose: () => void;
  selectedPaymentMethod: any;
}


const InsufficientPayment: React.FC<InsufficientPaymentProps> = ({ 
  show,
  receiptId,
  receipt ,
  receipts, 
  setCurrentIndex, 
  onClose,
  setReceipts, 
  selectedPaymentMethod,
   }) => {
  const [loading, setLoading] = useState(false);
  // keep the input empty by default (no predefined 0)
  const [insufficientAmount, setInsufficientAmount] = useState<string>('');
  const [showPayAndClose, setShowPayAndClose] = useState(false);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    // allow empty string while typing
    if (raw === '') {
      setInsufficientAmount('');
      return;
    }
    // normalize comma decimal separator
    const normalized = raw.replace(/,/g, '.');
    // remove non numeric characters except dot
    const cleaned = normalized.replace(/[^0-9.]/g, '');
    setInsufficientAmount(cleaned);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent minus, exponent and plus characters which allow negative or exponential input
    const key = e.key;
    if (key === '-' || key === '+' || key.toLowerCase() === 'e') {
      e.preventDefault();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const text = e.clipboardData.getData('Text').replace(/,/g, '.').trim();
    const parsed = Number(text);
    if (isNaN(parsed) || parsed < 0) {
      // prevent invalid paste
      e.preventDefault();
      return;
    }
    // allow paste; we'll sanitize via onChange
  };

  const handleBlur = () => {
    setInsufficientAmount((prev) => {
      if (prev === '') return '';
      const parsed = Number(prev);
      if (isNaN(parsed) || parsed <= 0) return '';
      return String(Math.max(0, parsed));
    });
  };


  const handlePayPartially = (close: boolean) => {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const userId = user.user_id ? Number(user.user_id) : 0;
    // convert empty string to 0 for API, but do not force a displayed 0 in the input
    const amountToSend = insufficientAmount === '' ? 0 : Math.max(0, Number(insufficientAmount));
    
    // Check if selected payment method is custom
    const customPaymentTypeId = selectedPaymentMethod?.is_custom && selectedPaymentMethod?.custom_payment_type_id 
      ? selectedPaymentMethod.custom_payment_type_id 
      : null;
    
    setLoading(true);
    markPaymentReceiptAsPartiallyPayed(
      receiptId, 
      userId, 
      null, 
      selectedPaymentMethod?.payment_type_id ?? 0, 
      'parallel', 
      amountToSend, 
      close,
      customPaymentTypeId
    ).then((response) => {
      const updatedReceipts = receipts.map((r) => {
        if (r.receipt_id === receiptId) {
          return { ...r, active: !close, total_payed: r.total_payed + amountToSend, payed_full: (r.total_payed + amountToSend) === r.total_due };
        }
        return r;
      });
      setReceipts(updatedReceipts);
      toast.success('Recibo marcado como parcialmente pagado');
      setLoading(false);
      onClose();
      
      if (close) {
        // If closing the table, reload the window after a short delay
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else if (receipts.length > 1) {
        const nextReceiptIndex = receipts.findIndex((receipt) => !receipt.payed_full && receipt.receipt_id !== receiptId);
        if (nextReceiptIndex !== -1 && nextReceiptIndex !== undefined && nextReceiptIndex !== null) {
          setTimeout(() => setCurrentIndex(nextReceiptIndex), 2000);
        } else {
          setCurrentIndex(0);
        }
      }
    }).catch((error:any) => {
      console.error('Error marking receipt as partially payed: ', error);
      toast.error('Error marcando recibo como parcialmente pagado');
      setLoading(false);
    });
  };


  const renderHandleInsufficientPayment = () => {
    const numericInsufficient = insufficientAmount === '' ? 0 : Number(insufficientAmount || 0);
    const remainingAmount = receipt.total_due - receipt.total_payed - numericInsufficient;
    return (
      <div className='insufficient-payment-container'>
        <div className='insufficient-payment-amount'>
          <FormControl
            type='number'
            placeholder='Ingrese cantidad...'
            value={insufficientAmount}
            min={0}
            step='0.01'
            onChange={handleAmountChange}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            onBlur={handleBlur}
            autoFocus
          />
        </div>
        <div className='insufficient-payment-actions'>
          <Button className='insufficient-payment-button primary' onClick={() => handlePayPartially(false)}>
            <FaMoneyBillWave/> Abonar
          </Button>
          <Button className='insufficient-payment-button secondary' onClick={() => setShowPayAndClose(true)}>
            <FaBan/> Cerrar mesa
          </Button>
          <Button className='insufficient-payment-button cancel' onClick={() => onClose()}>
            <FaX/> Cancelar
          </Button>
        </div>
        <Modal className="confirmation-modal" show={showPayAndClose} onHide={() => setShowPayAndClose(false)} centered>
          <Modal.Header>
            <div className='form-modal-title-container'>
              <Modal.Title className='form-modal-title'>Pagar y Cerrar</Modal.Title>
            </div>
            <Button variant="none" className="modal-close-button" onClick={() => setShowPayAndClose(false)}>
              <FaX />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <p className="confirmation-text">
              ¿Estás seguro? Esta opción aplicará el pago por el monto de <strong>{formatCurrency(numericInsufficient)}</strong>, dejando una deuda de <strong>{formatCurrency(remainingAmount)}</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="form-modal-footer-custom">
              <Button variant='secondary' className="form-button-cancel" onClick={() => setShowPayAndClose(false)}>
                Cancelar
              </Button>
              <Button variant='primary' className="form-button-create" onClick={() => {
                setShowPayAndClose(false);
                handlePayPartially(true);
              }}>
                Confirmar y Cerrar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };


  if (loading) {
    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Body>
          <MiniLoadingSpinner phrases={[]} left='45%' />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={onClose} centered className="insufficient-payment-modal">
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className="form-modal-title">
            Pago Insuficiente
          </Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onClose}>
          <FaX />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {renderHandleInsufficientPayment()}
      </Modal.Body>
    </Modal>
  );
};

export default InsufficientPayment;
